import React, { useState } from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useSubmit from 'hooks/useSubmit';
import InvitationService from 'services/api/AdminInvitations';
import SuccessMessage from '../SuccessMessage';

type DeleteInvitationModalProps = {
  invitationId: number
  onClose: () => void,
  reloadData: () => void,
};

function DeleteInvitationModal( {
  invitationId, onClose, reloadData,
}: DeleteInvitationModalProps ) {
  const { t } = useTranslation();
  const [formSubmitted, setFormSubmitted] = useState( false );
  const [formSubmittedError, setFormSubmittedError] = useState<string>();

  const deleteEvent = useSubmit( {
    promise: () => InvitationService.deleteAdminInvitation( invitationId ),
    callbackError: ( errors ) => {
      setFormSubmitted( true );
      setFormSubmittedError( errors );
    },
    callback: ( ) => {
      setFormSubmitted( true );
      setFormSubmittedError( undefined );
      reloadData();
    },
    showAlert: false,
    deps: [invitationId],
  } );

  return (
    <Modal
      show
      centered
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">{ t( 'admin.common.deleteInvitation' )}</h3>
            {formSubmitted
              ? (
                <SuccessMessage
                  description={formSubmittedError || t( 'admin.common.deleteEventSuccess' )}
                  onClose={onClose}
                  success={!formSubmittedError}
                />
              )
              : (
                <div className="text-center">
                  <p className="text--sm">
                    {t( 'admin.common.deleteInvitationMsg' )}
                  </p>

                  <Row>
                    <Col className="m-auto mt-3">
                      <Button
                        variant="danger"
                        className="btn--full-width"
                        onClick={deleteEvent}
                      >
                        {t( 'admin.common.delete' )}
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteInvitationModal;
